import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { SanctionedGroupMySuffix } from 'src/app/shared/model/sanctioned-group-my-suffix.model';
import { SanctionedGroupMySuffixService } from './sanctioned-group-my-suffix.service';
import { SanctionedGroupMySuffixComponent } from './sanctioned-group-my-suffix.component';
import { SanctionedGroupMySuffixDetailComponent } from './sanctioned-group-my-suffix-detail.component';
import { SanctionedGroupMySuffixUpdateComponent } from './sanctioned-group-my-suffix-update.component';
import { SanctionedGroupMySuffixDeletePopupComponent } from './sanctioned-group-my-suffix-delete-dialog.component';
import { ISanctionedGroupMySuffix } from 'src/app/shared/model/sanctioned-group-my-suffix.model';

@Injectable({ providedIn: 'root' })
export class SanctionedGroupMySuffixResolve implements Resolve<ISanctionedGroupMySuffix> {
    constructor(private service: SanctionedGroupMySuffixService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            if (state.url.includes('/view')) {
                return this.service.view(id).map((sanctionedGroupView: HttpResponse<SanctionedGroupMySuffix>) => sanctionedGroupView.body);
            }
            return this.service.find(id).map((sanctionedGroup: HttpResponse<SanctionedGroupMySuffix>) => sanctionedGroup.body);
        }
        return Observable.of(new SanctionedGroupMySuffix());
    }
}

export const sanctionedGroupRoute: Routes = [
    {
        path: 'sanctioned-group',
        component: SanctionedGroupMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'SanctionedGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'sanctioned-group/:id/view',
        component: SanctionedGroupMySuffixDetailComponent,
        resolve: {
            sanctionedGroup: SanctionedGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'SanctionedGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'sanctioned-group/new',
        component: SanctionedGroupMySuffixUpdateComponent,
        resolve: {
            sanctionedGroup: SanctionedGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'SanctionedGroups'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'sanctioned-group/:id/edit',
        component: SanctionedGroupMySuffixUpdateComponent,
        resolve: {
            sanctionedGroup: SanctionedGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'SanctionedGroups'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const sanctionedGroupPopupRoute: Routes = [
    {
        path: 'sanctioned-group/:id/delete',
        component: SanctionedGroupMySuffixDeletePopupComponent,
        resolve: {
            sanctionedGroup: SanctionedGroupMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'SanctionedGroups'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
